import React from 'react'
import CclDataTable, { CclDataTableColumnType, CclDataTableColumnDef } from '../CclDataTable';
import Toaster from "../Toaster";
import ApiCustomerBlock from "../../code/api/ApiCustomerBlock";
import CustomerBlock from "../../code/models/CustomerBlock";

import "../../css/admincustomerblocksform.css";
import { CloseButton } from "reactstrap";
import ButtonConfirm, { ButtonConfirmSize } from "../ButtonConfirm";


interface IAdminCustomerBlocksForm { }

export default function AdminCustomerBlocksForm({ }: IAdminCustomerBlocksForm) {
  const [toastMessage, setToastMessage] = React.useState<string>("");
  const [customerBlocks, setCustomerBlocks] = React.useState<CustomerBlock[] | null>(null);
  const [selectedBlock, setSelectedBlock] = React.useState<CustomerBlock | null>(null);
  const [editBlock, setEditBlock] = React.useState<CustomerBlock | null>(null);
  const [anyChanges, setAnyChanges] = React.useState<boolean>(false);

  React.useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    ApiCustomerBlock.getCustomerBlocks().then(data => {
      setCustomerBlocks(data);
    });
  }

  const profileColumnDefs: CclDataTableColumnDef[] = [
    {
      fieldName: "companyEmployeeId",
      title: "Id",
      visible: true,
      type: CclDataTableColumnType.Data,
      className: "col-1"
    }, {
      fieldName: "name",
      title: "Name",
      visible: true,
      type: CclDataTableColumnType.Data,
      className: "col-2"
    }, {
      fieldName: "reason",
      title: "Reason",
      visible: true,
      type: CclDataTableColumnType.Data,
      className: "col-md-9"
    }
  ];

  function handleRowSelect(rowData: CustomerBlock): void {
    setSelectedBlock(rowData);
    setEditBlock(structuredClone(rowData));
    setAnyChanges(false);

  }

  function checkHasChanges() {
    var changes = editBlock?.companyEmployeeId !== selectedBlock?.companyEmployeeId ||
      editBlock?.reason !== selectedBlock?.reason;

    setAnyChanges(changes);
  }

  function saveChanges(): void {
    if (!editBlock || !selectedBlock) return;
    ApiCustomerBlock.updateCustomerBlock(editBlock).then((result) => {
      if (result) {
        setToastMessage(`Customer Id "${editBlock?.companyEmployeeId}" has been saved.`);
        setSelectedBlock(null);
        setEditBlock(null);
        loadData();
      }
    });
  }

  function handleDeleteBlock(confirm: boolean) {
    if (!selectedBlock || !confirm) return;
    ApiCustomerBlock.deleteCustomerBlock(selectedBlock.companyEmployeeId).then(() => {
      setSelectedBlock(null);
      setEditBlock(null);
      loadData();
    });
  }

  function addNewClick(): void {
    setSelectedBlock(new CustomerBlock());
    setEditBlock(new CustomerBlock());
  }

  function cancelChangesClick(): void {
    setSelectedBlock(null);
    setEditBlock(null);
  }

  return (
    <React.Fragment>
      <div className='container-fluid h-100'>
        <div className={"row custblock-editor" + (!!selectedBlock ? "" : " closed")}>
          {!selectedBlock && !editBlock &&
            <div className="col-1 custblock-add-button">
              <button className="btn btn-outline-primary" onClick={addNewClick}>Add</button>
            </div>}
          {!!selectedBlock && !!editBlock &&
            <React.Fragment key={`blk-${selectedBlock.companyId}-${selectedBlock.companyEmployeeId}`}>
              <div className="col-1">
                <label htmlFor="compEmpId" className="form-label">Id</label>
                <input className="form-control" id="compEmpId"
                  defaultValue={selectedBlock.companyEmployeeId} autoComplete={"off"} maxLength={255}
                  disabled={selectedBlock.companyId > 0}
                  onChange={(e) => {
                    editBlock.companyEmployeeId = e.target.value;
                    checkHasChanges();
                  }}></input>
              </div>
              <div className="col-6">
                <label htmlFor="compReason" className="form-label">Reason</label>
                <input className="form-control" id="compReason"
                  defaultValue={selectedBlock.reason}
                  autoComplete={"off"} maxLength={1024}
                  onChange={(e) => {
                    editBlock.reason = e.target.value;
                    checkHasChanges();
                  }}></input>
              </div>
              <div className="col-3 custblock-buttons">
                <button disabled={!anyChanges} className="btn btn-primary custblock-save-button"
                  onClick={saveChanges}>Save Changes</button>
                <button className="btn btn-primary custblock-cancel-button" onClick={cancelChangesClick}>Cancel</button>
                {selectedBlock.companyId > 0 && <ButtonConfirm enabled={!anyChanges} buttonText="Delete" confirmTitle={"Delete Block"} confirmMessage={selectedBlock.companyEmployeeId}
                  buttonSize={ButtonConfirmSize.Normal} cssClass="btn btn-outline-danger custblock-delete-button"
                  onConfirm={handleDeleteBlock} />}
              </div>
            </React.Fragment>}
        </div>
        <div className={"row custblock-table" + (!!selectedBlock ? "" : " closed")}>
          <CclDataTable
            name={"custBlocksTable"}
            tableData={customerBlocks || []}
            columnDefinitions={profileColumnDefs}
            rowSelect={true}
            onRowSelect={handleRowSelect}
            onButtonClick={() => { }} />
        </div>
      </div>
      <Toaster title="Profiles" subtitle="info" message={toastMessage} key={"custInfdetailtoast"} />
    </React.Fragment>
  )
}
